// src/hooks/useNotifications.ts
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import type { Notification } from '@/mocks/notifications';
import { mockNotifications } from '@/mocks/notifications';
import { logError } from '@/utils/logger';

export function useNotifications() {
    const { t } = useTranslation();
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                setIsLoading(true);
                // TODO: Replace with actual API call
                // const response = await api.get('/notifications');
                // setNotifications(response.data);
                
                // Temporary mock data
                setNotifications(mockNotifications);
            } catch (err: unknown) {
                const error = err instanceof Error ? err : new Error(t("error.notifications.failedToFetchNotifications"));
                setError(error);
                logError('Error fetching notifications', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchNotifications();
    }, []);

    const markAsRead = async (notificationId: number) => {
        try {
            // TODO: Replace with actual API call
            // await api.put(`/notifications/${notificationId}/read`);
            
            setNotifications(prevNotifications =>
                prevNotifications.map(notification =>
                    notification.id === notificationId
                        ? { ...notification, read: true }
                        : notification
                )
            );
        } catch (err) {
            const error = err instanceof Error ? err : new Error(t("error.notifications.failedToMarkNotificationAsRead"));
            setError(error);
            logError('Error marking notification as read', error);
        }
    };

    const markAllAsRead = async () => {
        try {
            // TODO: Replace with actual API call
            // await api.put('/notifications/read-all');
            
            setNotifications(prevNotifications =>
                prevNotifications.map(notification => ({ ...notification, read: true }))
            );
        } catch (err) {
            const error = err instanceof Error ? err : new Error(t("error.notifications.failedToMarkNotificationAsRead"));
            setError(error);
            logError('Error marking all notifications as read', error);
        }
    };

    return {
        notifications,
        isLoading,
        error,
        markAsRead,
        markAllAsRead
    };
} 